var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getOptionsWithoutFixed = function (optionsArray) {
    var retArr = [];
    for (var i = 0; i < optionsArray.length; i++) {
        if (!optionsArray[i].isFixed) {
            retArr.push(optionsArray[i]);
        }
    }
    return retArr;
};
export var getOptionsOnlyFixed = function (optionsArray) {
    var _a;
    var retArr = [];
    for (var i = 0; i < optionsArray.length; i++) {
        if (optionsArray[i].isFixed) {
            retArr = __spreadArray(__spreadArray([], retArr, true), [optionsArray[i]], false);
        }
        else if (optionsArray[i].options) {
            retArr = __spreadArray(__spreadArray([], retArr, true), getOptionsOnlyFixed((_a = optionsArray[i].options) !== null && _a !== void 0 ? _a : []), true);
        }
    }
    return retArr;
};
